"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatedPromptImpulse = void 0;
var Prompt_1 = require("./Prompt");
/**
 * Impulse which indicates the result of a update prompt impulse
 */
var UpdatedPromptImpulse = /** @class */ (function (_super) {
    __extends(UpdatedPromptImpulse, _super);
    function UpdatedPromptImpulse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "UpdatedPromptImpulse";
        _this.id = function () {
            _this.push(function (_) { return "id"; });
        };
        /**
         * the prompt instance
         */
        _this.data = function (config) { return _this.push(function (registry) {
            var entity = new Prompt_1.Prompt();
            config(entity);
            return "data { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return UpdatedPromptImpulse;
}(Array));
exports.UpdatedPromptImpulse = UpdatedPromptImpulse;
//# sourceMappingURL=UpdatedPromptImpulse.js.map